export const utcFormat = 'YYYY-MM-DDTHH:mm:ss[Z]';

export const dateShowFormat = 'L';
export const dateTimeShowFormat = 'L HH:mm';
export const dateTimeWithSecondsShowFormat = 'L HH:mm:ss';
export const hoursMinutesShowFormat = 'HH:mm';
export const hoursMinutesSecondsShowFormat = 'HH:mm:ss';

export const generalDateTimeWithSecondsShowFormat = 'L HH:mm:ss';

export const dateExportFileFormat = 'yyyy-MM-DD';
